import { push } from 'connected-react-router';
import ActionTypes from './ActionTypes';
import { OidcSettings } from '../constants';
import {
  AuthenticationService,
  NotificationService,
  ExecutiveService
} from '../services';

export const login = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.LOGIN_USER });
    const user = await AuthenticationService.login();
    dispatch({
      type: ActionTypes.LOGIN_USER_SUCCESS,
      payload: user
    });
    dispatch(push('/'));
  } catch (e) {
    dispatch({ type: ActionTypes.LOGIN_USER_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillUserRegisterFromLoggedUser = loggedUser => dispatch =>
  dispatch({
    type: ActionTypes.FILL_USER_REGISTER_FROM_LOGGED_USER,
    payload: loggedUser
  });

export const logout = () => async dispatch => {
  const token = AuthenticationService.getLoggedUser();

  await AuthenticationService.logout();

  const logoutUrl = `${
    process.env.REACT_APP_API_SECURITY_URL
  }/Account/Logout?id_token_hint=${token.id_token}&post_logout_redirect_uri=${
    OidcSettings.post_logout_redirect_uri
  }`;

  window.location.href = logoutUrl;
};

export const verifyIfUserIsLogged = () => async dispatch => {
  let user = AuthenticationService.userIsLogged()
    ? AuthenticationService.getLoggedUser()
    : null;

  if (user) {
    const executive = await AuthenticationService.getLoggedExecutive(
      user.profile.sub
    );
    if (executive) user = { ...user, executive };
  }

  dispatch({
    type: ActionTypes.VERIFY_LOGGED_USER_SUCCESS,
    payload: user
  });
};

export const updateAuthEmail = email => dispatch => {
  dispatch({
    type: ActionTypes.UPDATE_AUTH_EMAIL,
    payload: email || ''
  });
};

export const updateLoginField = ({ prop, value }) => ({
  type: ActionTypes.UPDATE_LOGIN_FIELD,
  payload: { prop, value }
});

export const updatePasswordRecoveryField = ({ prop, value }) => ({
  type: ActionTypes.UPDATE_PASSWORD_RECOVERY_FIELD,
  payload: { prop, value }
});
